<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <!-- لودینگ ذخیره خودکار -->
      <v-overlay :value="isAutoSaving" z-index="9999" opacity="0.8" v-if="AutoSave">
        <div class="text-center d-flex flex-column align-center justify-center">
          <atom-spinner :animation-duration="1500" :size="100" class="mx-auto" color="#038118"/>
          <h3 class="mt-4 green--text">در حال ذخیره‌سازی خودکار...</h3>
          <p class="green--text mt-2">لطفاً چند لحظه صبر کنید</p>
        </div>
      </v-overlay>

      <v-row class="pa-2" no-gutters>
        <!-- حالت ویرایش مستقیم Gateway در صورت وجود -->
        <v-col cols="12" v-if="showGatewayPopup">
          <qr-edit-gateway
            v-model="showGatewayPopup"
            :sections="specialInfoSingle"
            :form-data="bankCard"
            @edit-all="handleEditAll"
            @save="qrUpdate(false)"
            @cancel="onCancel"
          >
            <template v-slot:preview style="position: relative; min-height: 100%;">
              <v-card
                v-if="loading"
                class="d-flex align-center justify-center mt-10"
                flat
                min-height="50vh"
              >
                <v-progress-circular indeterminate size="50" width="5" color="gray" />
              </v-card>
              <div v-else class="sticky-preview">
                <v-tabs-items
                  v-model="qrShow"
                  class="overflow-visible mb-4 mb-md-0"
                  touchless
                >
                  <v-tab-item>
                    <qr-maker :loading="loading" />
                  </v-tab-item>

                  <v-tab-item>
                    <view-bank-card :value="bankCard"  :qr-svg-data-url="qrSvgDataUrl"/>
                  </v-tab-item>
                </v-tabs-items>
              </div>
            </template>
          </qr-edit-gateway>
        </v-col>

        <!-- نمای اصلی استپر و پیش‌نمایش -->
        <template v-if="!showGatewayPopup">
          <!-- تب‌های بالا سمت چپ -->
          <v-col class="pa-2 mb-4 sticky-md" cols="12" md="4" style="top: 12px">
          </v-col>

          <v-col v-show="$vuetify.breakpoint.mdAndUp" cols="8" />

          <!-- ستون پیش‌نمایش -->
          <v-col
            class="pa-2 sticky-md"
            cols="12"
            md="4"
            style="top: 110px; height: fit-content"
          >
                <view-bank-card :value="bankCard" :qr-svg-data-url="qrSvgDataUrl"/>
          </v-col>

          <!-- فرم استپر -->
          <v-col class="pa-2 px-0" cols="12" md="8">
            <v-row class="pa-2" justify="start" style="width: 100%">
              <v-stepper v-model="e6" class="px-0 mx-0 qr-stepper" flat vertical>
                <!-- استپ ۱: نام و آدرس کیوآر -->
                <v-stepper-step :complete="e6 > 1" class="px-0 px-md-4" step="1">
                  <v-row no-gutters>
                    <v-col class="pa-2" cols="12">
                      <p class="font-weight-bold">ویرایش اطلاعات کیوار کیوکارت</p>
                    </v-col>

                    <v-col class="pa-2 d-flex row rowinfo" cols="12" md="6">
                      <v-text-field
                        v-model="res.title"
                        :disabled="e6 > 1"
                        :error-messages="errors['title']"
                        append-icon="mdi-credit-card-outline"
                        class="mt-0 pt-0 contentinfo"
                        clear-icon="mdi-close-circle-outline"
                        clearable
                        dense
                        label="نام کیوار کیوکارت"
                        outlined
                      />
                      <help-info
                        :element-name="`${serviceName}-${componentName}-visitName`"
                        :service-name="serviceName"
                        :help-data="helpData"
                        class="buttoninfo"
                        label="نام کیوار کیوکارت"
                      />
                    </v-col>

                    <v-col class="pa-2 rowinfo" cols="12" md="6">
                      <qr-address-field
                        id="qr-address"
                        ref="address-field"
                        v-model="res.identifier"
                        :error-messages="errors['identifier']"
                        append-icon="mdi-web"
                        class="ma-0 pa-0 contentinfo"
                        width="88%"
                        dense
                        outlined
                        persistent-hint
                        @updateDest="domainId = $event"
                        readonly
                        :key="$t('qrAddressUpdate.hints.allowedChars')"
                        :hint="$t('qrAddressUpdate.hints.allowedChars')"
                      />
                      <help-info
                        :element-name="`${serviceName}-${componentName}-dtUrl`"
                        :label="$t('qr_address')"
                        :service-name="serviceName"
                        :help-data="helpData"
                        class="buttoninfo"
                      />
                    </v-col>
                  </v-row>
                </v-stepper-step>

                <v-stepper-content step="1">
                  <div class="col-md-12">
                    <next-btn
                      :loading="loading"
                      style="background: #1b8d39"
                      @click="qrUpdate(false)"
                    />
                  </div>
                </v-stepper-content>

                <!-- استپ ۲: آیتم‌ها و محتوا -->
                <v-stepper-step :complete="e6 > 2" class="px-0 px-md-4" step="2">
                  {{ $t("info") }}
                </v-stepper-step>

                <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="2">
                  <!-- <div class="d-flex row mx-2 mt-3 mb-4 justify-start doublebtn">
                    <help-info
                      class="buttoninfo mx-0"
                      :element-name="`${serviceName}-${componentName}-clearDefaults`"
                      :label="$t('remove_default_info')"
                      :service-name="serviceName"
                      :help-data="helpData"
                    />
                  </div> -->

                  <!-- سوییچ و راهنمای ذخیره خودکار -->
                  <div class="mb-4 mx-4">
                    <div class="d-flex align-center">
                      <v-switch
                        v-model="AutoSave"
                        color="primary"
                        class="mt-0 pt-0 shrink"
                        hide-details
                        label="ذخیره خودکار"
                      ></v-switch>

                      <v-tooltip bottom max-width="320">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            icon
                            x-small
                            class="mr-1"
                            v-bind="attrs"
                            v-on="on"
                            @click.stop
                          >
                            <v-icon small color="grey darken-1">
                              mdi-help-circle-outline
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>
                          تغییرات هر بخش با بستن آن بخش به‌صورت خودکار ذخیره می‌شود.
                        </span>
                      </v-tooltip>
                    </div>

                    <div
                      v-if="$vuetify.breakpoint.xsOnly"
                      class="text-caption grey--text text--darken-1 mt-1 pr-1"
                      style="line-height: 1.4"
                    >
                      تغییرات هر بخش با بستن آن بخش به‌صورت خودکار ذخیره می‌شود.
                    </div>
                  </div>

                  <!-- لیست بازشونده ۳ بخش -->
                  <list-expansion
                    v-model="bankCard"
                    :components="specialInfo"
                    :data="bankCard"
                    flat
                    @save-required="AutoSave && qrUpdate(false)"
                  />

                  <div class="col-md-12">
                    <next-btn
                      :loading="loading"
                      style="background: #1b8d39"
                      @click="qrUpdate(true)"
                    />
                  </div>
                </v-stepper-content>
              </v-stepper>

            </v-row>
          </v-col>
        </template>
      </v-row>
    </template>
  </help-info-wrapper>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import QrMaker from "@/view/pages/qrland/components/qrMaker";
import ListExpansion from "../../content/fragments/listExpansion";
import NextBtn from "../../content/fragments/nextBtn";
import PrevBtn from "../../content/fragments/prevBtn";
import QrAddressField from "../../content/fragments/qrAddressField";
import QrCodeMake from "@/view/pages/qrland/qrCodeStyle/qrCodeMake.vue";
import { getLanguageCookie } from "@/core/plugins/TitleRibbon/utils/languageCookie";
import viewBankCard from "./viewBankCard.vue";
import Tariffs from "../../components/Tariffs/Tariffs.vue";
import QrEditGateway from "../qrland/components/QrEditGateway.vue";
import { AtomSpinner } from "epic-spinners";

export default {
  name: "editBankCard",

  components: {
    viewBankCard,
    QrCodeMake,
    QrAddressField,
    PrevBtn,
    NextBtn,
    ListExpansion,
    QrMaker,
    Tariffs,
    QrEditGateway,
    AtomSpinner,
  },

  data() {
    return {
      isAutoSaving: false,
      AutoSave: false,
      showGatewayPopup: this.$route?.query?.gateway === "true",
      loading: false,
      bankCard: {
        language: "fa",
        langs: {
          source_lang: "fa",
          other_langs: [],
        },
        infoUser: {
          nameCollection: "",
          subTitle: "",
          logoImage: "/media/defaults/qrLogo.webp",
          background: "https://cdn.terminalads.com/upload/9be5a015e903852f5c0e1645e905f73e.webp",
        },
        cardBank: {
          displayType: "list",
          sizeLevel: 2,
          cardTheme: "white",
          list: [],
        },
        theme: "",
        visitName: "کیوکارت",
        pallete: {
          bodyColor: "linear-gradient(to top right , #020040A7, #BBDAFFFF)",
          textColor: "#FFFAE9FF",
          buttonColor: "linear-gradient(to top right , #020040A7, #BBDAFFFF)",
        },
        apiKey: "GAPGPTMASKTOKEN43ujqyinxhkX0X",
      },

      res: {
        title: "",
        identifier: "",
        domain: { name: "" },
        qrId: null,
      },
      helpData: [],
      componentName: "bankcard",
      serviceName: "Qrland",
      qrDesign: {},
      e6: 2,
      errors: {},
      domainId: null,
      qrShow: 1, // پیش‌فرض روی پیش‌نمایش
      qrSvgDataUrl: "",
      currentEditingLang: "fa",
    };
  },

  mounted() {
    const savedLanguage = getLanguageCookie() || "fa";
    this.$i18n.locale = savedLanguage;

    this.$root.$on("editvisit-lang-change", (lang) => {
      this.currentEditingLang = lang;
    });

    if (this.showGatewayPopup) {
      this.qrShow = 1;
    }

    this.fetchData();
  },

  watch: {
    "$i18n.locale"(newLocale, oldLocale) {
      if (newLocale !== oldLocale) {
        localStorage.setItem("language", newLocale);
      }
    },
  },

  computed: {
    ...mapGetters("localstorage", ["createQrID", "alllangs", "defaultLang"]),

    specialInfo() {
      return [
        {
          name: "AddAccount",
          value: "",
          title: "افزودن اطلاعات کاربر",
          subtitle: "",
          icon: "account-outline",
          model: "infoUser",
        },
        {
          name: "ManagementAccountBank",
          value: "",
          title: "مدیریت حساب ها",
          subtitle: "",
          model: "cardBank",
          icon: "credit-card-outline",
        },
        {
          name: "ManagementColor",
          value: "",
          title: "مدیریت رنگ",
          icon: "palette",
          model: "pallete",
        },
      ];
    },

    specialInfoSingle() {
      const descriptionKeys = {
        AddAccount: "edit_multicard_special_info_single.add_account_description",
        ManagementAccountBank: "edit_multicard_special_info_single.management_account_description",
        ManagementColor: "edit_multicard_special_info_single.management_color_description",
      };

      return this.specialInfo.map((item) => {
        const descriptionKey = descriptionKeys[item.name];
        return {
          ...item,
          description: descriptionKey ? this.$t(descriptionKey) : "",
        };
      });
    },

    fullLink() {
      return this.res.domain?.name?.replace("/", "") + "/" + this.res.identifier;
    },

    domainName() {
      return this.$route.params?.name?.replace("?gateway=true", "");
    },

    qrIdParam() {
      return this.$route.params?.id?.replace("?gateway=true", "");
    },
  },

  methods: {
    ...mapActions("localstorage", [
      "setCreatedQrID",
      "setLangList",
      "setDefaultLang",
      "setMainData",
    ]),

    onCancel() {
      this.$router.push({ name: "qr.list" });
    },

    handleEditAll() {
      this.showGatewayPopup = false;
    },

    fetchData() {
      this.loading = true;
      const url = `/v1/testQr/find/${this.domainName}${
        this.qrIdParam ? "/" + this.qrIdParam : ""
      }`;

      this.$api
        .get(url)
        .then(({ data }) => {
          const responseData = data.data;
        this.qrSvgDataUrl= data?.data?.img_url||''; 
          this.setCreatedQrID(responseData.id);

          this.setLangList(
            responseData?.lang
              ?.split(",")
              ?.filter((l) => l !== responseData?.default) || []
          );
          this.setDefaultLang(responseData?.default || "fa");

          let info = responseData.data;
          const currentLang =
            this.defaultLang || getLanguageCookie() || info.language || "fa";

          this.currentEditingLang = currentLang;
          this.$root.$emit("mobile-viewer-lang-change", this.currentEditingLang);

          if (info.data) {
            info.data.language = currentLang;
            info.data.langs = {
              source_lang:
                this.defaultLang || info.data.langs?.source_lang || "fa",
              other_langs:
                this.alllangs?.map((x) => ({ lang: x, status: "edited" })) || [],
            };
          }

          this.res = responseData;
          this.res.language = currentLang;

          // ادغام دیتای سرور با ساختار پیش‌فرض برای اطمینان از وجود کلیدها
          this.bankCard = {
            ...this.bankCard,
            ...info.data,
            cardBank: {
              ...this.bankCard.cardBank,
              ...(info.data?.cardBank || {}),
            },
            infoUser: {
              ...this.bankCard.infoUser,
              ...(info.data?.infoUser || {}),
            },
            pallete: {
              ...this.bankCard.pallete,
              ...(info.data?.pallete || {}),
            },
          };

          this.setMainData({
            data: {
              data: this.bankCard,
              theme: this.bankCard.theme || "",
              lang: this.bankCard.language,
            },
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },

    qrUpdate(final = false) {
      if (final || !this.AutoSave) {
        this.loading = true;
      } else {
        this.isAutoSaving = true;
      }
      this.errors = {};
      const currentLang = this.currentEditingLang;
      const sourceLang = this.bankCard.langs?.source_lang || "fa";

      const data = new URLSearchParams();
      data.append("type", "bankcard");
      data.append("qrType", "dynamic");
      data.append("title", this.res.title);
      data.append("domain", this.res.domain.name);
      data.append("identifier", this.res.identifier);

      if (this.res.qrId) {
        data.append("qr_id", this.res.qrId);
      }

      this.bankCard.language = this.defaultLang || getLanguageCookie() || "fa";

      data.append(
        "data",
        JSON.stringify({
          data: this.bankCard,
        })
      );

      if (currentLang === sourceLang) {
        return this.saveToMainQr(data, final);
      } else {
        const content = {
          data: {
            data: this.bankCard,
          },
        };
        return this.saveToLangFtp(currentLang, final, content);
      }
    },

    saveToMainQr(data, final) {
      return this.$api
        .put("/v1/testQr/update", data, {
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
        })
        .then(() => {
          if (final || !this.isAutoSaving) {
            this.$toast.success("کیوآر کیوکارت با موفقیت ویرایش شد.");
          }
          if (final) this.goto("qr.list");
          this.e6 = 2;
        })
        .catch((err) => {
          console.error(err);
          const msg = err.response?.data?.message || "خطا در ویرایش";
          this.$toast.error(msg);
        })
        .finally(() => {
          this.loading = false;
          this.isAutoSaving = false;
        });
    },

    saveToLangFtp(lang, final, content) {
      const allLangs = [this.defaultLang || "fa", ...this.alllangs];

      return this.$api
        .post(`/v1/testQr/update-lang-data/${this.createQrID}`, {
          lang: lang,
          data: content,
          langs: allLangs,
        })
        .then(() => {
          this.$toast.success(this.$t("language.saved"));
          if (final) this.goto("qr.list");
        })
        .catch((err) => {
          console.error(err);
          this.$toast.error("خطا در ذخیره زبان");
        })
        .finally(() => {
          this.loading = false;
          this.isAutoSaving = false;
        });
    },

    clearDefaults() {
      this.$root.$emit("clearDefaultData");
      if (this.bankCard.infoUser) {
        this.bankCard.infoUser.nameCollection = "";
        this.bankCard.infoUser.subTitle = "";
      }
      this.bankCard.visitName = "کیوکارت";
      this.bankCard.apiKey = "";
    },

    goto(pathName) {
      this.$router.push({ name: pathName });
    },
  },
};
</script>

<style scoped>
.v-tab--active {
  background-color: var(--v-primary-base) !important;
  border-radius: 50px;
  color: white;
}

.help-info-wrapper {
  display: inline-block;
  vertical-align: middle;
  margin-left: 1px;
}

qr-address-field {
  width: 88% !important;
}

.warp {
  position: relative;
  overflow: visible !important;
  min-height: 50px;
}

.doublebtn {
  gap: 8px;
}

.sticky-preview {
  position: -webkit-sticky;
  position: sticky;
  top: 0px !important;
  align-self: flex-start;
  height: max-content;
  z-index: 10;
}
</style>
